<template>
      <div class="container bg-gray-100 p-5">
        <router-link type="button" class="hover:underline" to="/">
            <svg class="h-8 w-8 fill-current text-blue-900" xmlns="http://www.w3.org/2000/svg" viewBox="274.835 394.86 54.965 55.15"><defs/><path d="M302.4 395.823c14.752.013 26.694 12.004 26.695 26.805.001 14.592-12.041 26.517-26.753 26.495-14.737-.023-26.754-11.98-26.684-26.551.072-14.873 11.958-26.763 26.742-26.749zm.342 32.534h2.447c3.522 0 7.044.033 10.565-.013 2.327-.03 3.413-1.138 3.479-3.442.039-1.364.033-2.731.003-4.096-.057-2.537-.978-3.536-3.514-3.605-2.801-.076-5.605-.022-8.408-.024-1.471-.001-2.942 0-4.571 0 0-1.899.247-3.457-.079-4.885-.254-1.114-1.01-2.527-1.934-2.949-.783-.357-2.422.2-3.171.899-3.518 3.284-6.88 6.737-10.254 10.171-1.618 1.646-1.652 3.053-.056 4.689 3.413 3.497 6.829 6.997 10.403 10.326.73.68 2.361 1.107 3.203.755.868-.363 1.601-1.754 1.812-2.811.3-1.513.075-3.132.075-5.015z"/></svg>
        </router-link>


        <!-- >Accidentes personales -->

        <div v-if="showAP" class="container bg-white rounded-lg mt-5 p-5 box-shadow">
            <svg @click="hideAP" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"/></svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">Accidentes personales</p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
                Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-5 mb-2">

            <v-select 
            :searchable="false"
            v-model="selectedAPCoverage" class="w-full md:w-2/5 lg:w-2/5 xl:w-2/5 shadow appearance-none border rounded text-grey-darker"
              :options="selectAPOptions">
                <template v-slot:no-options>
                    <template>
                        No hay resultados.
                    </template>
                </template>
            </v-select>
            </div>
        <div>

        <table class="mt-5 mb-5" style="width:100%">
          <tr v-for="benefit in benefitsAP.result[selectedAPCoverage.value != null ? selectedAPCoverage.value -1 : 0 ].benefits" :key="benefit.id">
            <td class="text-xs lg:text-base text-gray-800">{{benefit.name}}</td>
            <td class="text-xs lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(benefit.sum_assured)}}</td>
          </tr>
        </table>

            <p class="text-2xl text-center text-gray-800">Prima quincenal</p>
            <p class="text-4xl text-center text-green-500 italic mt-5">{{$filters.toCurrency(this.benefitsAP.result[selectedAPCoverage.value != null ? selectedAPCoverage.value -1 : 0 ].costo)}}</p>

            <div class="w-full p-2 text-center mt-5 mb-2">
                <button class="w-full flex justify-center items-center bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded">
                    Contratar <mdicon name="chevron-right" />
                </button>
            </div>
        </div>

        </div>

<!-- Indemnización por Cáncer -->

        <div v-if="showIC" class="container bg-white rounded-lg mt-5 p-5 box-shadow">
            <svg @click="hideIC" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"/></svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">Indemnización por Cáncer</p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
                Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-5 mb-2">

            <v-select 
            :searchable="false"
            v-model="selectedICCoverage" class="w-full md:w-2/5 lg:w-2/5 xl:w-2/5 shadow appearance-none border rounded text-grey-darker"
              :options="selectICOptions">
                <template v-slot:no-options>
                    <template>
                        No hay resultados.
                    </template>
                </template>
            </v-select>
            </div>
        <div>

        <table class="mt-5 mb-5" style="width:100%">
          <tr v-for="benefit in benefitsIC.result[selectedICCoverage.value != null ? selectedICCoverage.value -1 : 0 ].benefits" :key="benefit.id">
            <td class="text-xs lg:text-base text-gray-800">{{benefit.name}}</td>
            <td class="text-xs lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(benefit.sum_assured)}}</td>
          </tr>
        </table>

            <p class="text-2xl text-center text-gray-800">Prima quincenal</p>
            <p class="text-4xl text-center text-green-500 italic mt-5">{{$filters.toCurrency(this.benefitsIC.result[selectedICCoverage.value != null ? selectedICCoverage.value -1 : 0 ].costo)}}</p>

            <div class="w-full p-2 text-center mt-5 mb-2">
                <button class="w-full flex justify-center items-center bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded">
                    Contratar <mdicon name="chevron-right" />
                </button>
            </div>
        </div>

        </div>



<!-- Respaldo Hospitalario -->

        <div v-if="showRH" class="container bg-white rounded-lg mt-5 p-5 box-shadow">
            <svg @click="hideRH" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"/></svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">Respaldo Hospitalario</p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
                Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-5 mb-2">

            <v-select 
            :searchable="false"
            v-model="selectedRHCoverage" class="w-full md:w-2/5 lg:w-2/5 xl:w-2/5 shadow appearance-none border rounded text-grey-darker"
              :options="selectRHOptions">
                <template v-slot:no-options>
                    <template>
                        No hay resultados.
                    </template>
                </template>
            </v-select>
            </div>
        <div>

        <table class="mt-5 mb-5" style="width:100%">
          <tr v-for="benefit in benefitsRH.result[selectedRHCoverage.value != null ? selectedRHCoverage.value -1 : 0 ].benefits" :key="benefit.id">
            <td class="text-xs lg:text-base text-gray-800">{{benefit.name}}</td>
            <td class="text-xs lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(benefit.sum_assured)}}</td>
          </tr>
        </table>

            <p class="text-2xl text-center text-gray-800">Prima quincenal</p>
            <p class="text-4xl text-center text-green-500 italic mt-5">{{$filters.toCurrency(this.benefitsRH.result[selectedRHCoverage.value != null ? selectedRHCoverage.value -1 : 0 ].costo)}}</p>

            <div class="w-full p-2 text-center mt-5 mb-2">
                <button class="w-full flex justify-center items-center bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded">
                    Contratar <mdicon name="chevron-right" />
                </button>
            </div>
        </div>

        </div>



<!-- Indemnización por Enfermedades Graves -->

        <div v-if="showIE" class="container bg-white rounded-lg mt-5 p-5 box-shadow">
            <svg @click="hideIE" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"/></svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">Indemnización por Enfermedades Graves</p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
                Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-5 mb-2">

            <v-select
            :searchable="false"
             v-model="selectedIECoverage" class="w-full md:w-2/5 lg:w-2/5 xl:w-2/5 shadow appearance-none border rounded text-grey-darker"
              :options="selectIEOptions">
                <template v-slot:no-options>
                    <template>
                        No hay resultados.
                    </template>
                </template>
            </v-select>
            </div>
        <div>

        <table class="mt-5 mb-5" style="width:100%">
          <tr v-for="benefit in benefitsIE.result[selectedIECoverage.value != null ? selectedIECoverage.value -1 : 0 ].benefits" :key="benefit.id">
            <td class="text-xs lg:text-base text-gray-800">{{benefit.name}}</td>
            <td class="text-xs lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(benefit.sum_assured)}}</td>
          </tr>
        </table>

            <p class="text-2xl text-center text-gray-800">Prima quincenal</p>
            <p class="text-4xl text-center text-green-500 italic mt-5">{{$filters.toCurrency(this.benefitsIE.result[selectedIECoverage.value != null ? selectedIECoverage.value -1 : 0 ].costo)}}</p>

            <div class="w-full p-2 text-center mt-5 mb-2">
                <button class="w-full flex justify-center items-center bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded">
                    Contratar <mdicon name="chevron-right" />
                </button>
            </div>
        </div>

        </div>


<!-- Pérdida de Ingresos -->

        <div v-if="showPI" class="container bg-white rounded-lg mt-5 p-5 box-shadow">
            <svg @click="hidePI" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M215.788 488.478c-10.959 8.219-26.506 5.998-34.725-4.961-6.614-8.819-6.614-20.945 0-29.764l99.213-99.213c9.645-9.454 25.08-9.454 34.725 0l99.213 99.213c8.219 10.959 5.998 26.506-4.961 34.725-8.819 6.614-20.945 6.614-29.764 0l-81.851-81.603-81.851 81.851.001-.248z"/></svg>
            <p class="text-gray-700 text-center text-2xl lg:text-4xl mb-5">Pérdida de Ingresos</p>
            <p class="text-gray-600 text-center text-lg lg:text-xl">
                Selecciona la cantidad que deseas recibir de beneficio
            </p>

            <div class="w-full p-2 text-center mt-5 mb-2">

            <v-select 
            :searchable="false"
            v-model="selectedPICoverage" class="w-full md:w-2/5 lg:w-2/5 xl:w-2/5 shadow appearance-none border rounded text-grey-darker"
              :options="selectPIOptions">
                <template v-slot:no-options>
                    <template>
                        No hay resultados.
                    </template>
                </template>
            </v-select>
            </div>
        <div>

        <table class="mt-5 mb-5" style="width:100%">
          <tr v-for="benefit in benefitsPI.result[selectedPICoverage.value != null ? selectedPICoverage.value -1 : 0 ].benefits" :key="benefit.id">
            <td class="text-xs lg:text-base text-gray-800">{{benefit.name}}</td>
            <td class="text-xs lg:text-base text-gray-800" style="text-align: left;">{{$filters.toCurrency(benefit.sum_assured)}}</td>
          </tr>
        </table>

            <p class="text-2xl text-center text-gray-800">Prima quincenal</p>
            <p class="text-4xl text-center text-green-500 italic mt-5">{{$filters.toCurrency(this.benefitsPI.result[selectedPICoverage.value != null ? selectedPICoverage.value -1 : 0 ].costo) }}</p>

            <div class="w-full p-2 text-center mt-5 mb-2">
                <button class="w-full flex justify-center items-center bg-orange-600 hover:bg-orange-700 text-2xl text-white font-bold py-2 px-6 rounded">
                    Contratar <mdicon name="chevron-right" />
                </button>
            </div>
        </div>

        </div>

<div v-if="!showAP || !showIC || !showRH || !showIE || !showPI" class="container bg-white rounded-lg mt-5 p-5 box-shadow flex-col">
<div v-if="!showAP" class="w-full shadow-xs inline-flex items-center">
    <svg @click="hideAP" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"/></svg>
    <span @click="hideAP" class="cursor-pointer text-xl font-medium pl-2">Accidentes Personales</span>
</div>

<div v-if="!showIC" class="w-full shadow-xs inline-flex items-center">
    <svg @click="hideIC" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"/></svg>
    <span @click="hideIC" class="cursor-pointer text-xl font-medium pl-2">Indemnización por Cáncer</span>
</div>

<div v-if="!showRH" class="w-full shadow-xs inline-flex items-center">
    <svg @click="hideRH" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"/></svg>
    <span @click="hideRH" class="cursor-pointer text-xl font-medium pl-2">Respaldo Hospitalario</span>
</div>


<div v-if="!showIE" class="w-full shadow-xs inline-flex items-center">
    <svg @click="hideIE" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"/></svg>
    <span @click="hideIE" class="cursor-pointer text-xl font-medium pl-2">Indemnización por Enfermedades Graves</span>
</div>


<div v-if="!showPI" class="w-full shadow-xs inline-flex items-center">
    <svg @click="hidePI" class="cursor-pointer text-xl h-8 w-8 fill-current text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 125.445 595.28 590"><defs/><path d="M124.017 197.215h347.247c27.397 0 49.607 22.21 49.607 49.607v347.247c0 27.397-22.21 49.607-49.607 49.607H124.017c-27.397 0-49.607-22.21-49.607-49.607V246.822c0-27.284 22.323-49.607 49.607-49.607zm2.908 49.78v347.073h347.247V246.995H126.925z"/><path d="M379.492 352.412c10.959-8.219 26.506-5.998 34.725 4.961 6.614 8.819 6.614 20.945 0 29.764l-99.213 99.213c-9.645 9.454-25.08 9.454-34.725 0l-99.213-99.213c-8.219-10.959-5.998-26.506 4.961-34.725 8.819-6.614 20.945-6.614 29.764 0l81.851 81.603 81.851-81.851-.001.248z"/></svg>
    <span @click="hidePI" class="cursor-pointer text-xl font-medium pl-2">Pérdida de Ingresos</span>
</div>


    </div>


      </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import JsonObjeto from '../assets/cober.json';

const jsonCoverage = JsonObjeto.result

export default {
  name: 'Benefit',

  data() {
    return {
        cobertures: ["Accidentes Personales", "Indemnización por Cáncer", "Respaldo Hospitalario", "Indemnización por Enfermedades Graves", "Pérdida de Ingresos"],       
        coverage: jsonCoverage,
        showAP: false,
        showIC: false,
        showRH: false,
        showIE: false,
        showPI: false,
        selectedAPCoverage: [],
        selectedICCoverage: [],
        selectedRHCoverage: [],
        selectedIECoverage: [],
        selectedPICoverage: [],
        benefitsAP: JsonObjeto,
        benefitsIC: JsonObjeto,
        benefitsRH: JsonObjeto,
        benefitsIE: JsonObjeto,
        benefitsPI: JsonObjeto,
        listaBeneficios: null,
        jsonLength: null,
        value: 0,
        }
    },
    components: {
    },
  created() {
    this.getString();
  },
  methods:{
    getString(){
      this.listaBeneficios = this.benefitsAP.result
    },
    hideAP(){
        this.showAP = !this.showAP
    },
    hideIC(){
        this.showIC = !this.showIC
    },    
    hideRH(){
        this.showRH = !this.showRH
    },    
    hideIE(){
        this.showIE = !this.showIE
    },    
    hidePI(){
        this.showPI = !this.showPI
    }
  },
  computed:{
    selectAPOptions(){
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      return this.coverage.map(coverage => ({label: formatter.format(coverage.sum_assured), value: coverage.id}))
    },
    selectICOptions(){
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      return this.coverage.map(coverage => ({label: formatter.format(coverage.sum_assured), value: coverage.id}))
    },
    selectRHOptions(){
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      return this.coverage.map(coverage => ({label: formatter.format(coverage.sum_assured), value: coverage.id}))
    },
    selectIEOptions(){
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      return this.coverage.map(coverage => ({label: formatter.format(coverage.sum_assured), value: coverage.id}))
    },
    selectPIOptions(){
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
        });
      return this.coverage.map(coverage => ({label: formatter.format(coverage.sum_assured), value: coverage.id}))
    }
  }
}
</script>

<style scoped>
.box-shadow {
    border: 1px ;
    padding: 10px;
    box-shadow: 2px 10px 8px #888888;
}

</style>